/**
 * Converts the Product Samples app's price text (always rendered in the
 * shop's base currency, EUR) into whatever currency the customer currently
 * has selected via the site's country/currency switcher.
 *
 * Relies on window.Shopify.currency (active + rate), which Shopify sets
 * globally on every storefront page once currency conversion is enabled.
 * Runs on page load, on the app's own "sample-page-sticky:loaded" event,
 * and watches for any sample items inserted dynamically afterwards.
 */
(function () {
  var SAMPLE_PRICE_SELECTOR = '.product-samples-list__item-content-below-title';

  function formatConverted(baseAmount) {
    if (typeof Shopify === 'undefined' || !Shopify.currency || !Shopify.currency.active) {
      return null;
    }
    var rate = parseFloat(Shopify.currency.rate);
    if (isNaN(rate)) rate = 1;
    var currency = Shopify.currency.active;
    var converted = baseAmount * rate;

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency
      }).format(converted);
    } catch (e) {
      return converted.toFixed(2) + ' ' + currency;
    }
  }

  function getBaseAmount(el) {
    // Cache the original shop-currency amount the first time we see this
    // element, so repeated runs never convert an already-converted value.
    if (el.dataset.baseAmount) {
      return parseFloat(el.dataset.baseAmount);
    }
    var text = el.textContent || '';
    var match = text.match(/(\d+(?:[.,]\d+)?)/);
    if (!match) return null;
    var amount = parseFloat(match[1].replace(',', '.'));
    if (isNaN(amount)) return null;
    el.dataset.baseAmount = amount;
    return amount;
  }

  function updateSamplePrices() {
    var els = document.querySelectorAll(SAMPLE_PRICE_SELECTOR);
    if (!els.length) return;
    els.forEach(function (el) {
      var base = getBaseAmount(el);
      if (base === null) return;
      var formatted = formatConverted(base);
      if (formatted) el.textContent = formatted;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateSamplePrices);
  } else {
    updateSamplePrices();
  }

  // The Product Samples app fires this once its sticky/sidebar variant has
  // finished rendering — re-run in case items were added after initial load.
  document.body.addEventListener('sample-page-sticky:loaded', updateSamplePrices);

  // Belt-and-braces: catch any other case where the app injects sample
  // items into the DOM after the fact.
  var observer = new MutationObserver(function (mutations) {
    var shouldUpdate = false;
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (
          (node.classList && node.classList.contains('product-samples-list__item-content-below-title')) ||
          (node.querySelector && node.querySelector(SAMPLE_PRICE_SELECTOR))
        ) {
          shouldUpdate = true;
        }
      });
    });
    if (shouldUpdate) updateSamplePrices();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
